import { ExpenseItemEdit } from '@client/components/financials/expense-items/ExpenseItemEdit';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { claimFormStore } from '../store';

export const Route = createFileRoute('/console/$orgId/claims/details/$id/expenses/edit/$expenseItemId')({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Edit expense item',
        },
    },
    params: {
        parse({ expenseItemId }) {
            return {
                expenseItemId: BigInt(expenseItemId),
            };
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    const claim = claimFormStore.use.formData();
    const isReadonly = claimFormStore.use.isReadonly();
    const navigate = useNavigate();

    useEffect(() => {
        if (isReadonly) {
            navigate({ moveInMatches: -1 });
        }
    }, [isReadonly]);

    return (
        <ExpenseItemEdit
            action={['edit', Route.useParams().expenseItemId]}
            insurerId={claim.insurerId}
            handlingPartyIds={claim.HandlingParties.map(({ id }) => id)}
        />
    );
}
